<template>
    <v-dialog class="content-dialog" v-model="tableDialog" persistent :fullscreen="mobile">
        <div v-if="!table && loading" class="dialog-loading-container">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <v-card rounded="lg">
            <TableDialogHeader :tables="table" v-if="table" @close="closeDialog" />
            <v-divider></v-divider>
            <div class="content-dialog-card">
                <v-row>
                    <v-col cols="12" sm="6">
                        <div class="content-dialog-data-wrapper">
                            <TableDialogRawData :tables="table" v-if="table" />
                            <v-divider></v-divider>
                            <TableDialogData :tables="table" v-if="table" />
                            <TableDialogEmailAutomations v-if="emailAutomations" />
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <div class="table-dialog-leads-wrapper">
                            <TableDialogLeadsData :tables="table" v-if="table" />
                        </div>
                        <div>
                            <TableDialogRawLeads :tables="table" v-if="table" />
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12">
                        <TableDialogMapping :tables="table" v-if="table" />
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { useDisplay } from 'vuetify'
import TableDialogHeader from './TableDialogHeader.vue';
import TableDialogLeadsData from './TableDialogLeadsData.vue';
import TableDialogData from './TableDialogData.vue';
import TableDialogRawData from './TableDialogRawData.vue';
import TableDialogEmailAutomations from './TableDialogEmailAutomations.vue';
import TableDialogRawLeads from './TableDialogRawLeads.vue';
import TableDialogMapping from './TableDialogMapping.vue';
import { mapState, mapActions } from 'vuex';

export default {
    components: {
        TableDialogHeader,
        TableDialogLeadsData,
        TableDialogData,
        TableDialogRawData,
        TableDialogEmailAutomations,
        TableDialogRawLeads,
        TableDialogMapping
    },
    props: {
        tableId: {
            type: String,
            required: true
        }
    },
    setup() {
        const { mobile } = useDisplay();
        return { mobile };
    },
    data() {
        return {

        }
    },
    watch: {
        tableId: {
            handler(newId, oldId) {
                if (newId && newId !== oldId) {
                    this.fetchTableData(newId);
                }
            },
            immediate: true
        }
    },
    computed: {
        ...mapState('table', ['loading', 'table', 'tableDialog', 'emailAutomations'])
    },
    methods: {
        ...mapActions('table', ['fetchTableData', 'closeTableDialog', 'setTableDialog', 'resetTable']),
        closeDialog() {
            this.$store.dispatch('table/closeTableDialog');
        },
    },
    beforeUnmount() {
        this.resetTable();
    }

}
</script>

<style lang="scss" scoped></style>